import { IonRouterOutlet } from '@ionic/react';
import React from 'react';
import { Redirect, Route } from 'react-router';

import RoutePath from '@custom-types/RoutePath';
import Auth from '@pages/Auth';
import { Events } from '@pages/Event';
import Kiosk from '@pages/Kiosk';
import ManageMobi from '@pages/ManageMobi';
import People from '@pages/People';
import { PrintBadge } from '@pages/PrintBadge';
import Printer from '@pages/Printer';
import Sessions from '@pages/Session';
import { generateRoute } from '@services/navigation-service';
import { CommonRoutes } from 'src/CommonRoutes';

export const Onsite = () => (
  <IonRouterOutlet>
    <Route exact path={generateRoute(['', '/'])}>
      <Redirect
        to={{
          pathname: generateRoute(RoutePath.Login),
        }}
      />
    </Route>
    <Route path={generateRoute(RoutePath.Login)}>
      <Auth />
    </Route>
    <Route path={generateRoute(RoutePath.ManageMobi)}>
      <IonRouterOutlet>
        <Route exact path={generateRoute(RoutePath.ManageMobi)}>
          <ManageMobi />
        </Route>
      </IonRouterOutlet>
    </Route>

    <Route path={generateRoute(RoutePath.Event)}>
      <Events />
    </Route>

    <Route path={generateRoute(RoutePath.Session)}>
      <Sessions />
    </Route>

    <Route path={generateRoute(RoutePath.Kiosk)}>
      <Kiosk />
    </Route>

    <Route path={generateRoute(RoutePath.PrintBadge)} component={PrintBadge} />

    <Route path={generateRoute(RoutePath.Printer)}>
      <Printer />
    </Route>

    <Route path={generateRoute(RoutePath.People)}>
      <People />
    </Route>

    <Route path={generateRoute([RoutePath.Language, RoutePath.OpenApp, RoutePath.UpdateRequired])}>
      <CommonRoutes />
    </Route>
  </IonRouterOutlet>
);
